import _Textarea from './Textarea';
import './style';

export type { TextareaProps } from './Textarea';
export * from './type';

export const Textarea = _Textarea;
export default Textarea;
